import { ReactElement } from 'react';

import { successIcon, alertIcon } from './fixtures';

export interface GetFormValidationAdornment {
    hasError?: boolean;
    isValid?: boolean;
    validIcon?: ReactElement;
    errorIcon?: ReactElement;
    hasTertiaryOption?: boolean;
    tertiaryIcon?: ReactElement;
}

export const getFormValidationAdornment = ({
    hasError,
    isValid,
    validIcon = successIcon,
    errorIcon = alertIcon,
    hasTertiaryOption = false,
    tertiaryIcon = undefined,
}: GetFormValidationAdornment): ReactElement | undefined => {
    let adornment;

    if (hasError) {
        adornment = errorIcon;
    } else if (isValid) {
        adornment = validIcon;
    }

    if (hasTertiaryOption && tertiaryIcon) {
        adornment = tertiaryIcon;
    }

    return adornment;
};
